export const errorMessages: Record<string, { title: string; description: string }> = {
  tenant_mismatch: {
    title: "Farklı Microsoft 365 kuruluşu",
    description:
      "Bu çalışma alanına yalnızca ANL’nin Microsoft 365 hesabıyla giriş yapılabilir.",
  },
  access_not_provisioned: {
    title: "Uygulama erişiminiz tanımlı değil",
    description:
      "Kurumsal hesabınız doğrulandı; ancak ANL Platform kullanıcı kaydınız henüz oluşturulmamış.",
  },
  access_passive: {
    title: "Uygulama erişiminiz pasif",
    description:
      "Hesabınız Microsoft 365’te açık olsa bile bu uygulamadaki erişiminiz sistem yöneticisi tarafından pasife alınmış.",
  },
  invalid_state: {
    title: "Giriş isteği doğrulanamadı",
    description:
      "Güvenlik doğrulaması tamamlanamadı. Yeni bir kurumsal giriş başlatın.",
  },
  expired_state: {
    title: "Giriş süresi doldu",
    description:
      "Microsoft 365 giriş işlemi zaman aşımına uğradı. Yeniden deneyin.",
  },
  invalid_identity: {
    title: "Microsoft kimliği doğrulanamadı",
    description:
      "Microsoft 365 hesabınızın sabit kullanıcı kimliği alınamadı. Kurumsal hesabınızla yeniden giriş yapın.",
  },
  not_configured: {
    title: "Kurumsal giriş henüz hazır değil",
    description:
      "Microsoft 365 bağlantısı sistem yöneticisi tarafından tamamlanmalıdır. Lütfen Bilgi Teknolojileri birimiyle iletişime geçin.",
  },
};

